import config from '../config';
import { authHeader } from '../helpers/auth-header';
import { apiCall } from '../helpers/service-helper';


export const playerScoreService = {
    calculate,
    getScores
};

function calculate(playRoundId: number) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), ...{ 'Content-Type': 'application/json' } },
        body: JSON.stringify("")
    };

    return apiCall(`${config.apiUrl}/PlayerScore/${playRoundId}`, requestOptions);
}

function getScores() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return apiCall(`${config.apiUrl}/PlayerScore/scores`, requestOptions);
}
